function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M141.7 35.5c17.2 0 31.4 4.1 41.3 12 10.2 8.2 15.4 20.3 15.4 36.2v36.8H28.3v155.9h226.8V120.5h-28.3V83.6c0-24.6-9-44.8-26.1-58.4C185.8 13.3 165.4 7 141.8 7c-23.7 0-44 6.3-58.9 18.2C65.7 38.9 56.7 59 56.7 83.6v8.5H85v-8.5c0-15.9 5.2-28.1 15.4-36.2 9.9-7.8 24.2-11.9 41.3-11.9M56.7 248v-99.2h170.1V248H56.7z"
})));